import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase/firebase";

/**
 * Logs feature engagement to Firebase Analytics.
 * @param {string} featureName - The name of the feature used.
 * @param {string} userId - The user ID (optional for guest tracking).
 */
export const trackFeatureUsage = (featureName, userId = "guest") => {
    if (!featureName) return;
    logEvent(analytics, "feature_engagement", {
        feature: featureName,
        userId: userId,
        timestamp: Date.now(),
    });
};
